export enum Permission {
  CUSTOMIZER_ACCESS = "CUSTOMIZER_ACCESS",
  EMOTES_ACCESS = "EMOTES_ACCESS",
  SHAREABLE_LINKS_ACCESS = "SHAREABLE_LINKS_ACCESS",
  STUDENT_EGG_HATCHING = "STUDENT_EGG_HATCHING",
  TEACHER_SNAP_AND_SHARE_ACCESS = "TEACHER_SNAP_AND_SHARE_ACCESS",
  UGC_REPORT_ACCESS = "UGC_REPORT_ACCESS",
  HAS_BLOCK_INVENTORY = "HAS_BLOCK_INVENTORY",
  HAS_PERSISTENT_INVENTORY = "HAS_PERSISTENT_INVENTORY",
  HAS_BUILDING_PLOT = "HAS_BUILDING_PLOT",
  POCKET_WORLD_CREATE_GATEWAY = "POCKET_WORLD_CREATE_GATEWAY",
  POCKET_WORLD_CAN_BUILD = "POCKET_WORLD_CAN_BUILD",

  // sync player plot with other islands they are a part of
  SYNC_BUILDING_PLOT = "SYNC_BUILDING_PLOT",

  // player can see all other island member and guest names
  SEE_MEMBER_NAMES = "SEE_MEMBER_NAMES",

  // player can see the inviter's name and other guests from same inviter
  SEE_INVITER_NAMES = "SEE_INVITER_NAMES",

  // can see the top-right "Sign Up" button
  OPEN_SIGNUP_ACCESS = "OPEN_SIGNUP_ACCESS",

  HAS_FTUE = "HAS_FTUE",

  // can see the top-left island map button
  ISLAND_MAP_BUTTON = "ISLAND_MAP_BUTTON",
}
